import { defineNuxtPlugin } from '#app'
import { configure } from 'vee-validate'
import { localize } from '@vee-validate/i18n'
import fr from '@vee-validate/i18n/dist/locale/fr.json'

export default defineNuxtPlugin(() => {
    configure({
        generateMessage: localize({ fr }),
        validateOnBlur: true,
        validateOnChange: true,
        validateOnInput: false,
        validateOnModelUpdate: true,
    })
})
